import { ItemCardCustomization, SelectableMenuItem, ItemCardCustomizationType, MenuItemCardCustomization, SelectableItemCardCustomization, PortionItemType } from '@/models';

export function getNumberOfSelectedCustomizations(items: SelectableMenuItem[]): number {
  return items.reduce((acc, i) => {
    const customization = i.customizations.find(c => c.selected);

    const customizationCountTowards = customization ? getCountTowardsCustomizationMax(customization) : 0;
    const itemCountTowards = i.item.countTowardsCustomizationMax || 0;

    return customizationCountTowards + itemCountTowards + acc;
  }, 0);
}

export function getCountTowardsCustomizationMax(customization: ItemCardCustomization): number {
  switch (customization.type) {
    case ItemCardCustomizationType.Customization:
      return customization.customization.countTowardsCustomizationMax;

    case ItemCardCustomizationType.SelectableItem:
      return customization.item.item.countTowardsCustomizationMax || 0;

    case ItemCardCustomizationType.Normal:
      return 0;
  }
}

export function getNumberOfSelectedOnTheSideCustomizations(items: SelectableMenuItem[]): number {
  return items.reduce((acc, i) => {
    const customization = i.customizations.find(c => c.selected);

    const customizationCountTowards = customization ? getCountTowardsOnTheSideCustomizationMax(customization) : 0;

    return customizationCountTowards + acc;
  }, 0);
}

export function getCountTowardsOnTheSideCustomizationMax(customization: ItemCardCustomization): number {
  switch (customization.type) {
    case ItemCardCustomizationType.Customization:
      return customization.customization.countTowardsOnTheSideCustomizationMax;

    default:
      return 0;
  }
}

export function customizationsPartiallyEqual(left: ItemCardCustomization, right: ItemCardCustomization): boolean {
  if (left.type != right.type) {
    return false;
  }

  switch (left.type) {
    // There is only one default option so this must be it
    case ItemCardCustomizationType.Normal:
      return true;

    case ItemCardCustomizationType.Customization:
      return left.customization.id == (right as MenuItemCardCustomization).customization.id;

    case ItemCardCustomizationType.SelectableItem:
      return left.item.item.itemId == (right as SelectableItemCardCustomization).item.item.itemId;
  }
}

export function isExtraPortionItemCardCustomization(customization: ItemCardCustomization) {
  return customization.type == ItemCardCustomizationType.SelectableItem && (customization.portion || '') == PortionItemType.ExtraPortion;
}
